(function () {
  'use strict';

  const REDIRECT_COOKIE = 'checkoutRedirect';
  const PRODUCTS_COOKIE = 'checkoutRedirectProducts';

  const DEFAULT_REDIRECT_URL = 'https://leanfastform.com/';

  // const PRODUCT_REDIRECTS = {
  //   '9003059183773': 'https://summaup.typeform.com/to/l66Jzpjl',
  //   '8842318971037': 'https://summaup.typeform.com/to/l66Jzpjl',
  // };
  // Testing variables
  const PRODUCT_REDIRECTS = {
    '9234551832820': 'https://summaup.typeform.com/to/l66Jzpjl',
    '8842318971037': 'https://summaup.typeform.com/to/l66Jzpjl',
  };

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2 ? parts.pop().split(';').shift() : null;
  }

  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
  }

  function getProductIdsFromCookie() {
    const rawValue = getCookie(PRODUCTS_COOKIE);

    if (!rawValue) {
      return [];
    }

    try {
      const parsed = JSON.parse(decodeURIComponent(rawValue));
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (error) {
      console.warn('Failed to parse checkout product IDs cookie:', error);
      return [];
    }
  }

  function getRedirectUrl(productIds) {
    const matchedProductId = productIds.find((id) => PRODUCT_REDIRECTS[id]);

    return matchedProductId
      ? PRODUCT_REDIRECTS[matchedProductId]
      : DEFAULT_REDIRECT_URL;
  }

  function clearRedirectCookies() {
    deleteCookie(REDIRECT_COOKIE);
    deleteCookie(PRODUCTS_COOKIE);
  }

  function checkAndRedirect() {
    const shouldRedirect = getCookie(REDIRECT_COOKIE);

    if (!shouldRedirect) {
      return;
    }

    const productIds = getProductIdsFromCookie();
    const redirectUrl = getRedirectUrl(productIds);

    console.log('Checkout redirect product IDs:', productIds);
    console.log('Redirecting to:', redirectUrl);

    clearRedirectCookies();

    window.location.href = redirectUrl;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndRedirect);
  } else {
    checkAndRedirect();
  }
})();